/**
 * How long "AI isi semua" (110B) may take. Writing ten texts takes an AI 30–60 s:
 * the Worker gives the whole tap CW_DEADLINE_MS, one AI call at most
 * CW_AI_CALL_MS, and the editor waits CW_CLIENT_WAIT_MS (the API client's 20 s
 * default cut it off every time).
 *
 * Its own module: the API client is in the entry bundle, and importing these
 * from shared/fypCwAi.ts there pulled that whole module into it.
 */
export const CW_DEADLINE_MS = 150_000;
export const CW_AI_CALL_MS = 90_000;
export const CW_CLIENT_WAIT_MS = 180_000;
/** Below this, another AI is not worth starting: it would only be cut off. */
const CW_MIN_CALL_MS = 20_000;

/** How long the next AI call may take, or 0 when the tap's time is up. */
export function cwCallBudget(startedMs: number, nowMs: number): number {
  const left = CW_DEADLINE_MS - (nowMs - startedMs);
  return left < CW_MIN_CALL_MS ? 0 : Math.min(CW_AI_CALL_MS, left);
}
